import React, { ComponentType } from 'react';
import { Route } from 'react-router-dom';

export const withRouter = <T,>(ConnectedComponent, displayName?: string) => {
  const withRouterComponent: ComponentType<
    Omit<T, 'history' | 'match' | 'location'>
  > = (props) => (
    <Route
      render={(routeProps) => <ConnectedComponent {...routeProps} {...props} />}
    />
  );

  withRouterComponent.displayName =
    displayName ?? ConnectedComponent.displayName;

  return withRouterComponent;
};
